import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import i18n from '../i18n';
import {
  DEFAULT_LANGUAGE,
  getPathLanguage,
  getStoredLanguage,
  getSupportedLanguage,
  isRtlLanguage,
  setStoredLanguage,
} from '../i18nLanguages';

const getCurrentI18nLanguage = () =>
  getSupportedLanguage(i18n.resolvedLanguage || i18n.language);

const LanguageRouteSync = () => {
  const { pathname } = useLocation();
  const userLanguage = useSelector((state) => state.currentUser?.language);

  useEffect(() => {
    const nextLanguage =
      getPathLanguage(pathname) ||
      getSupportedLanguage(userLanguage) ||
      getStoredLanguage() ||
      DEFAULT_LANGUAGE;

    if (getCurrentI18nLanguage() !== nextLanguage) {
      i18n.changeLanguage(nextLanguage);
    }

    setStoredLanguage(nextLanguage);

    if (typeof document !== 'undefined') {
      document.documentElement.lang = nextLanguage;
      document.documentElement.dir = isRtlLanguage(nextLanguage) ? 'rtl' : 'ltr';
    }
  }, [pathname, userLanguage]);

  return null;
};

export default LanguageRouteSync;
